import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";

export const useSelectNotificationsForTransportOrder = (
    orderId: string
) => {
    const allNotifications = useAppSelector(
        (state) => state.notification.notifications
    );

    const notifications = useMemo(
        () => allNotifications.filter((n) => n.transportOrderId === orderId),
        [allNotifications, orderId]
    );

    return notifications;
};
